import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useParams } from 'react-router-dom'
import { AuthSelector } from '../../store/auth'
import { WelcomeHeader } from '../headers'

export const PublicLayout = () => {
  const { id = '' } = useParams()

  const isLoggedIn = useSelector(AuthSelector.isLoggedIn)

  if (isLoggedIn && id) {
    return <Navigate to={`/grants/${id}`} replace={true} />
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100%',
        minHeight: '100vh',
        maxHeight: '100vh',
      }}
    >
      <WelcomeHeader />
      <Box
        component="div"
        sx={{
          overflowY: 'auto',
          padding: '40px 24px 24px 24px',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  )
}
